import {Component, computed, input, model} from '@angular/core';
import {ResizeEvent} from 'angular-resizable-element';

@Component({
  selector: 'app-resizable-container',
  templateUrl: './resizable-container.component.html',
  standalone: false
})
export class ResizableContainerComponent {
  private readonly DEFAULT_MIN_HEIGHT = 100;
  minHeight = input<number>(this.DEFAULT_MIN_HEIGHT);
  defaultHeight = input.required<number>();
  size = model.required<number>();
  wasResized = computed(() => this.size() !== this.defaultHeight());

  validateResize = (event: ResizeEvent): boolean => {
    return event.rectangle.height >= this.minHeight();
  };

  onResizeEnd(event: ResizeEvent): void {
    this.size.set(event.rectangle.height);
  }

  onResetClick(): void {
    this.size.set(this.defaultHeight());
  }
}
